import * as React from 'react'

import classNames from 'classnames/bind'

import * as styles from './index.vanilla.css'

const cx = classNames.bind(styles)
interface Props {
  highlighted?: boolean
  onClick?: () => void
  compact?: boolean
}

export default function ListItem({
  children,
  compact,
  onClick,
  highlighted,
}: React.PropsWithChildren<Props>) {
  if (!children) return null

  const className = cx('item', {
    compact,
    highlighted,
    onClick,
  })

  const content = (
    <div className={styles.content}>
      <div className={styles.wrapper}>{children}</div>
    </div>
  )

  return (
    <div onClick={onClick} className={className}>
      {content}
    </div>
  )
}
